import Route from '@ember/routing/route'
import type BigBooksController from 'teacher-ui-client/subscription-type/big-books/controller'

export default class BigBooksRoute extends Route {
  queryParams = {
    bigBookLevel: {
      replace: true,
      refreshModel: false,
    },
    keywords: {
      replace: true,
      refreshModel: false,
    },
  }

  model() {
    const { subscriptionType } = this.modelFor('subscription-type') as ModelForSubscriptionTypeRoute
    return { subscriptionType }
  }

  resetController(controller: BigBooksController) {
    controller.bigBookLevel = 'all'
  }
}
